import {BaseModel} from '.'

class RegisteredClass extends BaseModel {
  defaults () {
    return {
      ageGroup: null,
      type: null,
      count: 0
    }
  }

  options () {
    return {
      identifier: 'ageGroup'
    }
  }
}

export {RegisteredClass}



//////////////////
// WEBPACK FOOTER
// ./src/models/RegisteredClass.js
// module id = 340
// module chunks = 1